var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboardLeftFootprint(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5129 11.4716C17.6859 13.1203 15.715 13.6727 13.7504 12.8186C10.9649 11.6078 11.213 10.3208 7.09749 8.21449C6.96409 8.14607 6.91153 7.98224 6.9791 7.84721L8.8892 4.03944C8.94233 3.93328 9.05753 3.87271 9.17458 3.88933C10.6151 4.09209 11.9745 4.36522 13.3128 4.82886C17.9703 6.44181 19.4624 9.57861 18.5129 11.4716Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.24069 3.7745L6.31257 7.619C6.25201 7.73945 6.11364 7.79931 5.98572 7.75978C5.64002 7.65317 4.91511 7.40256 3.95981 6.92587C2.30678 6.10108 1.99182 4.82419 2.69982 3.41287C3.40782 2.00155 4.62132 1.48715 6.27414 2.3118C7.22924 2.78834 7.86508 3.21709 8.15802 3.42886C8.26651 3.50761 8.30139 3.65383 8.24105 3.77443L8.24069 3.7745Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardLeftFootprint);
export default __webpack_public_path__ + "static/media/dashboardLeftFootprint.51cafddf94c2c9cea80f1d9c18f8f664.svg";
export { ForwardRef as ReactComponent };